import { WorkspaceInfo as View } from 'ui-components'
import { useGetCurrentWorkspace } from '~workspace/queries/useGetWorkspaceById'

const WorkspaceInfo = () => {
  const { isLoading, data } = useGetCurrentWorkspace()

  return (
    <View
      loading={isLoading}
      workspace={data}
    />
  )
}

export { WorkspaceInfo }
